/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
import { IRespuesta } from '@infotrack/presentacion-transversales/interfacesComunes';
import manejadorRest from '@infotrack/presentacion-utilitarios/manejadorRest';
import { negocioConfiguracion } from '../../conexiones';
import IBodegasPersonas from './entidades/bodegasPersonas';
import IBodegasPersonasCompuesta from './entidades/bodegasPersonasCompuesta';
import IBodegasPersonasFiltro from './entidades/bodegasPersonasFiltro';

export default class ModeloBodegasPersonas {
    public consultarBodegasPersonas() {
        return manejadorRest<IRespuesta<IBodegasPersonas>>(() =>
            negocioConfiguracion.get('BodegasPersonas/ConsultarListaBodegasPersonas')
        );
    }

    public consultarBodegasPersonasCompuesta(bodegasPersonas: IBodegasPersonasFiltro) {
        return manejadorRest<IRespuesta<IBodegasPersonasCompuesta>>(
            () => negocioConfiguracion.post('BodegaUsuario/ConsultarBodegaPersonaCompuesta', bodegasPersonas),
            true
        );
    }  

    public crearBodegasPersonas(bodegasPersonas: IBodegasPersonas) {
        return manejadorRest<IRespuesta<IBodegasPersonas>>(() =>
            negocioConfiguracion.post('BodegaUsuario/GuardarBodegaPersona', bodegasPersonas)
        );
    }

    public editarBodegasPersonas(bodegasPersonas: IBodegasPersonas) {
        return manejadorRest<IRespuesta<IBodegasPersonas>>(() =>
            negocioConfiguracion.put('BodegaUsuario/EditarBodegaPersona', bodegasPersonas)
        );
    }

    public eliminarBodegasPersonas(bodegasPersonas: IBodegasPersonas) {
        return manejadorRest<IRespuesta<IBodegasPersonas>>(() =>
            negocioConfiguracion.delete('BodegaUsuario/EliminarBodegaPersona', bodegasPersonas)
        );
    }
}
